import React from 'react'
import OtpOne from '../../Components/OptOne/OtpOne'

const Otp2 = () => {
  return (
    <div><OtpOne resend='Resend sms' resendColor='#FB384B'/></div>
  )
}

export default Otp2